import { io, ManagerOptions, Socket, SocketOptions as SocketIOClientOptions } from 'socket.io-client'

import { OFFLINE_AUTH_KEY } from '@/constants/offline-auth'
import { getEnv } from '@/utils/helpers'
import { RootState } from '@/redux/rootReducer'

type SocketOptions = Partial<ManagerOptions & SocketIOClientOptions>

let socket: Socket

export function createSocket(options?: SocketOptions): Socket {
  const url = /^(?:[a-z]+:)?\/\//i.test(getEnv('VITE_API_URL')!) ? new URL(getEnv('VITE_API_URL')!) : new URL(getEnv('VITE_API_URL')!, window.location.origin)

  return io(`${url.protocol}//${url.hostname}:${url.port}`, options)
}

export function getSocket(options?: SocketOptions): Promise<Socket> {
  // Check if we're offline or in offline mode
  const offlineAuthData = localStorage.getItem(OFFLINE_AUTH_KEY)
  const isOffline = !navigator.onLine
  const isInOfflineMode = offlineAuthData && !navigator.onLine

  if (!socket) {
    // In offline mode, create socket without auto-connecting
    if (isOffline || isInOfflineMode) {
      socket = createSocket({ autoConnect: false })
      return Promise.resolve(socket)
    }

    // Online mode - create socket and wait for connection
    socket = createSocket(options)
    return new Promise((resolve) => {
      socket.on('connect', () => {
        resolve(socket!)
      })
    })
  }

  return Promise.resolve(socket)
}

export function createDMPConnectSocket(): Promise<WebSocket> {
  const url = getEnv('VITE_DMPCONNECT_URL') ?? 'https://localhost.icanopee.net:9982'
  const wsUrl = url.replace('http', 'ws')
  const dmpConnectSocket = new WebSocket(wsUrl)
  return new Promise((resolve) => {
    dmpConnectSocket.onopen = () => {
      resolve(dmpConnectSocket)
    }
    dmpConnectSocket.onerror = (error) => {
      console.log(error)
    }
  })
}

export function getSocketAuthOptions(state: RootState) {
  return {
    auth: {
      token: state.auth.tokens.access,
    },
  }
}
